var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.59199V11.4003C1.5 13.167 1.5 13.167 3.16667 14.292L7.75 16.942C8.44167 17.342 9.56667 17.342 10.25 16.942L14.8333 14.292C16.5 13.167 16.5 13.167 16.5 11.4087V6.59199C16.5 4.83366 16.5 4.83366 14.8333 3.70866L10.25 1.05866C9.56667 0.658659 8.44167 0.658659 7.75 1.05866L3.16667 3.70866C1.5 4.83366 1.5 4.83366 1.5 6.59199Z",
    stroke: "#1670D3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.4999C9.66304 11.4999 10.2989 11.2365 10.7678 10.7676C11.2366 10.2988 11.5 9.66291 11.5 8.99987C11.5 8.33683 11.2366 7.70094 10.7678 7.2321C10.2989 6.76326 9.66304 6.49987 9 6.49987C8.33696 6.49987 7.70107 6.76326 7.23223 7.2321C6.76339 7.70094 6.5 8.33683 6.5 8.99987C6.5 9.66291 6.76339 10.2988 7.23223 10.7676C7.70107 11.2365 8.33696 11.4999 9 11.4999Z",
    stroke: "#1670D3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDetails);
export default __webpack_public_path__ + "static/media/button-details.dee29edc09419ddc1bf6395031f70866.svg";
export { ForwardRef as ReactComponent };